import axios from "axios";

const API_BASE = String(import.meta.env.VITE_API_BASE_URL || "").replace(/\/+$/, "");
const query = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim()) search.set(key, String(value).trim());
  });
  return search.toString() ? `?${search}` : "";
};

async function request(method, path, data, config = {}) {
  const response = await axios({ method, url: `${API_BASE}${path}`, data, timeout: 60000, validateStatus: (status) => status >= 200 && status < 500, ...config });
  if (response.status >= 400 || response.data?.ok === false) throw new Error(response.data?.message || response.data?.error || `Erro HTTP ${response.status}`);
  return response.data?.data ?? response.data;
}

export const fetchProcessSnapshot = (filters) => request("get", `/api/processos/snapshot${query(filters)}`);
export const fetchProcessMeta = () => request("get", "/api/processos/meta");
export const fetchProcessInstance = (id) => request("get", `/api/processos/instances/${encodeURIComponent(id)}`);
export const performProcessAction = (id, action, payload = {}) => request("post", `/api/processos/instances/${encodeURIComponent(id)}/actions/${encodeURIComponent(action)}`, payload);
export const validateProcessBatch = (payload) => request("post", "/api/processos/instances/batch/validate", payload);

export const saveMatrixRule = (payload) => request(payload.id ? "put" : "post", `/api/processos/matrix/rules${payload.id ? `/${encodeURIComponent(payload.id)}` : ""}`, payload);
export const deleteMatrixRule = (id) => request("delete", `/api/processos/matrix/rules/${encodeURIComponent(id)}`);
export const simulateMatrixRule = (payload) => request("post", "/api/processos/matrix/simulate", payload);
export const publishMatrix = (payload) => request("post", "/api/processos/matrix/publish", payload);

export const saveProcessCatalog = (payload) => request(payload.id ? "put" : "post", `/api/processos/catalog${payload.id ? `/${encodeURIComponent(payload.id)}` : ""}`, payload);
export const publishProcessCatalog = (id, payload) => request("post", `/api/processos/catalog/${encodeURIComponent(id)}/publish`, payload);

export const previewProcessCsv = (fileName, content) => request("post", "/api/processos/imports/preview", { fileName, content });
export const commitProcessCsv = (previewId) => request("post", "/api/processos/imports/commit", { previewId });
export const reconcileProcesses = (payload = {}) => request("post", "/api/processos/integration/reconcile", payload);
export const updateProcessSettings = (payload) => request("put", "/api/processos/settings", payload);
export const updateProcessAlert = (id, payload) => request("patch", `/api/processos/alerts/${encodeURIComponent(id)}`, payload);

async function download(path, fallbackName) {
  const response = await axios.get(`${API_BASE}${path}`, { timeout: 60000, responseType: "blob" });
  const disposition = String(response.headers?.["content-disposition"] || "");
  const matched = disposition.match(/filename\*?=(?:UTF-8''|\")?([^\";]+)/i);
  const fileName = matched ? decodeURIComponent(matched[1].replaceAll('"', "")) : fallbackName;
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export const downloadProcessCsv = (filters) => download(`/api/processos/export.csv${query(filters)}`, "pop-fin-04.csv");
export const downloadProcessPdf = (filters) => download(`/api/processos/export.pdf${query(filters)}`, "fechamento-pop-fin-04.pdf");
export const downloadProcessTemplate = () => download("/api/processos/imports/template.csv", "pop-fin-04-modelo.csv");

